import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  min-width: 350px;
  padding: 40px 40px 80px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const EmojiWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 40px;
  font-weight: 600;
  line-height: 46px;
`;

export const TextWrapper = styled.div`
  display: flex;
  max-width: 500px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const Description = styled.span`
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
